import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IToolPanelAngularComp } from 'ag-grid-angular';
import { GridApi, IToolPanelParams } from 'ag-grid-enterprise';

@Component({
  selector: 'app-export-tool-panel',
  templateUrl: './export-tool-panel.component.html',
  styleUrl: './export-tool-panel.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExportToolPanelComponent implements IToolPanelAngularComp {
  constructor() {}

  parentComponent: any;
  GridApi?: GridApi;

  // The init(params) method is called on the tool panel once upon component initialization
  agInit(params: IToolPanelParams): void {
    const {
      api: GridApi,
      context: { componentParent: parentComponent }
    } = params;
    Object.assign(this, { parentComponent, GridApi });
  }

  // Called when `api.refreshToolPanel()` is called (with the current params).
  // Also called when the `sideBar` grid option is updated (with the updated params).
  // When `sideBar` is updated, if this method returns `true`,
  // then the grid will take no further action.
  // Otherwise, the tool panel will be destroyed and recreated.
  refresh(params: IToolPanelParams): boolean | void {
    return true;
  }

  // If saving and restoring state, this should return the current state.
  getState(): any {}

  exportFilteredData() {
    if (!this.GridApi) {
      throw new Error('Grid Api has not been registered.');
    }

    this.parentComponent.exportAfterDataReload = 'csv';
    this.parentComponent.loadAllRows = true;
    this.GridApi.refreshServerSide();
  }

  exportAllData() {
    if (!this.GridApi) {
      throw new Error('Grid Api has not been registered.');
    }
    this.parentComponent.loadAllData = true;
    this.parentComponent.exportAfterDataReload = 'csv';
    this.GridApi.refreshServerSide();
  }
}
